// 业务切换（排五 / 证券）：记在 localStorage，工作台、接量、获客素材、教程共用同一个选择。
// 切换时派发自定义事件，同一页面里的多个组件同步更新。
import { useState, useEffect, useCallback } from 'react';

const KEY = 'biz_mode';
const EVT = 'biz-mode-changed';

export function getBizMode() {
  try { return localStorage.getItem(KEY) === 'puzzle' ? 'puzzle' : 'legacy'; } catch { return 'legacy'; }
}

export function setBizMode(mode) {
  const m = mode === 'puzzle' ? 'puzzle' : 'legacy';
  try { localStorage.setItem(KEY, m); } catch {}
  try { window.dispatchEvent(new Event(EVT)); } catch {}
}

export function useBizMode() {
  const [mode, setMode] = useState(getBizMode);
  useEffect(() => {
    const sync = () => setMode(getBizMode());
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener('storage', sync); };
  }, []);
  const change = useCallback((m) => setBizMode(m), []);
  return [mode, change];
}
